import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class BillItem extends Component {
    Comma = (num) => {
        if (typeof num === 'number') {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
            return ''
        }
    }

    render() {
        //날짜 변환
        const newDate = new Date(this.props.item.createdAt)
        const newYear = newDate.getFullYear()
        const week = new Array('일', '월', '화', '수', '목', '금', '토')
        const newDayName = week[newDate.getDay()]

        let newMonth = newDate.getMonth() + 1
        if (newMonth < 10) {
            newMonth = '0' + newMonth
        }
        let newDay = newDate.getDate()
        if (newDay < 10) {
            newDay = '0' + newDay
        }

        newDate.setHours(12)
        newDate.setMinutes(0)
        newDate.setSeconds(0)
        newDate.setMilliseconds(0)
        const dueDateSec = newDate.getTime()

        const nowTime = new Date()
        nowTime.setHours(12)
        nowTime.setMinutes(0)
        nowTime.setSeconds(0)
        nowTime.setMilliseconds(0)
        const nowDateSec = nowTime.getTime()

        let gap = dueDateSec - nowDateSec
        gap = Math.floor(gap / (1000 * 60 * 60 * 24))

        let totalAmount = 0
        this.props.item.items.forEach((item) => {
            totalAmount += item.amount
        })

        const StatusStr = {
            READY: '대기',
            SENT: '발신완료',
            IN_PROGRESS: '수신완료',
            REMIT: '송금 완료',
            REMIT_REJECT: '송금 거절',
            CHECKED_REMIT: '입금 확인',
        }

        return (
            <Link to={`/budget/bills/${this.props.item._id}`}>
                <li>
                    <div className="title_wrap">
                        <p className="title">{this.props.item.title}</p>
                        <p className="price">
                            <span>{this.Comma(totalAmount)}</span>원
                        </p>
                    </div>
                    <div className="date_wrap">
                        <p className="date">
                            {newYear}.{newMonth}.{newDay} ({newDayName})
                        </p>
                        {this.props.item.status === 'CHECKED_REMIT' || this.props.item.status === 'REMIT_REJECT' ? (
                            <p className="dday dday_complete">{StatusStr[this.props.item.status]}</p>
                        ) : (
                            <p className="dday dday_blue">{StatusStr[this.props.item.status]}</p>
                        )}
                    </div>
                </li>
            </Link>
        )
    }
}

export default BillItem



// WEBPACK FOOTER //
// ./Src/Components/Contract/BillItem.js